module.exports = __webpack_public_path__ + "static/media/11.Plate-Compactor.df2d6e0d.webp";